<template>
  <div>
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="">
        <PageHeaderPart
          :pageHeaderImage="pageTopImage"
          pageHeaderImageAltText="Vas Head Image"
          :pageHeading="$root.selectedLanguageData.vas"
          :pageInfo="$root.selectedLanguageData.vas_next_line"
        />
        <!-- sms -->
        <div class="is-flex is-justify-content-space-between mt-5">
          <div>
            <label
              >{{ $root.selectedLanguageData.sms
              }}<span class="has-text-danger">*</span></label
            >
          </div>
          <div>
            <div
              id="sms-toggle-buttons"
              class="toggle-button toggle-change has-text-centered"
              style="
                background-color: #f9f9f9;
                /*opacity: 0.5;*/
                cursor: not-allowed;
              "
            >
              <div
                id="sms-yes-button"
                class="yes yes-active is-size-5 toggle-common"
                @click="smsYesClick()"
              >
                {{ $root.selectedLanguageData.yes }}
              </div>
              <div
                id="sms-no-button"
                class="no no-active is-size-5 toggle-common"
                @click="
                  () => {
                    smsNoClick();
                  }
                "
              >
                {{ $root.selectedLanguageData.no }}
              </div>
            </div>
          </div>
        </div>

        <!-- ebanking  -->
        <div class="is-flex is-justify-content-space-between mt-5">
          <div>
            <label
              >{{ $root.selectedLanguageData.ebanking
              }}<span class="has-text-danger">*</span></label
            >
          </div>
          <div>
            <div
              id="e-banking-toggle-buttons"
              class="toggle-button toggle-change has-text-centered"
              style="
                background-color: #f9f9f9;
                /*opacity: 0.5;*/
                cursor: not-allowed;
              "
            >
              <div
                id="e-banking-yes-button"
                class="yes yes-active is-size-5 toggle-common"
                @click="eBankingYesClick()"
              >
                {{ $root.selectedLanguageData.yes }}
              </div>
              <div
                id="e-banking-no-button"
                class="no no-active is-size-5 toggle-common"
                @click="
                  () => {
                    eBankingNoClick();
                  }
                "
              >
                {{ $root.selectedLanguageData.no }}
              </div>
            </div>
          </div>
        </div>

        <!-- Virtual Wallet -->
        <div class="is-flex is-justify-content-space-between mt-5">
          <div>
            <label
              >{{ $root.selectedLanguageData.virtualWallet
              }}<span class="has-text-danger">*</span></label
            >
          </div>
          <div>
            <div
              id="virtual-wallet-toggle-buttons"
              class="toggle-button toggle-change has-text-centered"
              style="
                background-color: #f9f9f9;
                /*opacity: 0.5;*/
                cursor: not-allowed;
              "
            >
              <div
                id="virtual-wallet-yes-button"
                class="yes yes-active is-size-5 toggle-common"
                @click="virtualWalletYesClick()"
              >
                {{ $root.selectedLanguageData.yes }}
              </div>
              <div
                id="virtual-wallet-no-button"
                class="no no-active is-size-5 toggle-common"
                @click="
                  () => {
                    virtualWalletNoClick();
                  }
                "
              >
                {{ $root.selectedLanguageData.no }}
              </div>
            </div>
          </div>
        </div>
        <!-- Estatement -->
        <div class="is-flex is-justify-content-space-between mt-5">
          <div>
            <label
              >{{ $root.selectedLanguageData.estatement
              }}<span class="has-text-danger">*</span></label
            >
          </div>
          <div>
            <div
              id="estatement-toggle-buttons"
              class="toggle-button toggle-change has-text-centered"
              style="
                background-color: #f9f9f9;
                /*opacity: 0.5;*/
                cursor: not-allowed;
              "
            >
              <div
                id="estatement-yes-button"
                class="yes yes-active is-size-5 toggle-common"
                @click="estatementYesClick()"
              >
                {{ $root.selectedLanguageData.yes }}
              </div>
              <div
                id="estatement-no-button"
                class="no no-active is-size-5 toggle-common"
                @click="
                  () => {
                    estatementNoClick();
                  }
                "
              >
                {{ $root.selectedLanguageData.no }}
              </div>
            </div>
          </div>
        </div>
        <!-- Debit Card* -->

        <div class="is-flex is-justify-content-space-between mt-5">
          <div>
            <label
              >{{ $root.selectedLanguageData.debitCard
              }}<span class="has-text-danger">*</span></label
            >
          </div>
          <div>
            <div
              id="debit_card-toggle-buttons"
              class="toggle-button toggle-change has-text-centered"
              style="background-color: #f9f9f9"
            >
              <div
                id="debit_card-yes-button"
                class="yes yes-active is-size-5 toggle-common"
                @click="debitCardYesClick"
              >
                {{ $root.selectedLanguageData.yes }}
              </div>
              <div
                id="debit_card-no-button"
                class="no no-active is-size-5 toggle-common"
                @click="
                  () => {
                    debitCardNoClick();
                  }
                "
              >
                {{ $root.selectedLanguageData.no }}
              </div>
            </div>
          </div>
        </div>

        <!-- if debit card Yes bellow section will appear -->
        <div v-if="$root.formData.debit_card_service">

<!--          <InputLabel-->
<!--            required="true"-->
<!--            styles="mt-5"-->
<!--            :label="$root.selectedLanguageData.account_to_be_linked"-->
<!--            v-model="$root.formData.account_to_be_linked"-->
<!--            :validationRules="{ required: true }"-->
<!--            fieldName="Account to be linked"-->
<!--          />-->


<!--          <InputLabel-->
<!--            required="true"-->
<!--            styles="mt-5"-->
<!--            :label="$root.selectedLanguageData.account_to_be_linked"-->
<!--            v-model="$root.formData.account_to_be_linked"-->
<!--            :validationRules="{ required: true }"-->
<!--            fieldName="Account to be linked"-->
<!--          />-->

          <InputLabel
            required="true"
            styles="mt-5"
            :label="$root.selectedLanguageData.name_that_should_appear"
            v-model="$root.formData.facility_debit_card_customer_name"
            :validationRules="{ required: true, alphaSpaces: true, notStartsWith:' ', lessOrEqualLength: 30}"
            fieldName="Name that should appear on card"

          />
          <InputLabel
            required="true"
            styles="mt-5"
            :label="$root.selectedLanguageData.maiden_name"
            v-model="$root.formData.mother_maiden_name"
            :validationRules="{ required: true, alphaSpaces: true }"
            fieldName="Mother maiden name"
          />
          <div>
            <label
              >{{ $root.selectedLanguageData.selectTheCardType
              }}<span class="has-text-danger">*</span></label
            >
            <div>
              <ValidationProvider
                name="This field"
                :rules="{ required: true }"
                v-slot="{ errors }"
              >

<!--             <b-field>-->
<!--                  <b-radio-->
<!--                    native-value="Visa Card"-->
<!--                    v-model="$root.formData.facility_debit_card_type"-->
<!--                    ><span-->
<!--                      ><img-->
<!--                        src="@/assets/images/icons/CardImages/Visa.webp"-->
<!--                        alt="visa-img"-->
<!--                        width="50px"-->
<!--                        height="50px" /></span-->
<!--                    >{{ $root.selectedLanguageData.visaCard }}-->
<!--                  </b-radio>-->
<!--                </b-field>-->

<!--                <b-field>-->
<!--                  <b-radio-->
<!--                    native-value="Mastercard"-->
<!--                    v-model="$root.formData.facility_debit_card_type"-->
<!--                    ><span-->
<!--                      ><img-->
<!--                        src="@/assets/images/icons/CardImages/Mastercard.webp"-->
<!--                        alt="mastercard-img"-->
<!--                        width="50px"-->
<!--                    /></span>-->
<!--                    {{ $root.selectedLanguageData.masterCard }}-->
<!--                  </b-radio>-->
<!--                </b-field>-->
<!--                <b-field>-->
<!--                  <b-radio-->
<!--                    native-value="JCBcard"-->
<!--                    v-model="$root.formData.facility_debit_card_type"-->
<!--                    ><span-->
<!--                      ><img-->
<!--                        src="@/assets/images/icons/CardImages/JCB.png"-->
<!--                        alt="jcbcard-img"-->
<!--                        width="50px"-->
<!--                    /></span>-->
<!--                    {{ $root.selectedLanguageData.jcb_card }}-->
<!--                  </b-radio>-->
<!--                </b-field>-->
                <b-field v-for="selectCard in cardArray" :key="selectCard.id">
                  <b-radio
                      :native-value="selectCard.card_type"
                      v-model="$root.formData.facility_debit_card_type">
                    <span>
                      <img :src="selectCard.card_image" :alt="selectCard.card_type + '-img'" width="50px" />
                    </span>
                    {{ selectCard.card_type }}
                  </b-radio>
                </b-field>
                <span class="has-text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <RadioButtonField
            :label="$root.selectedLanguageData.card_delivery_detail"
            :validationRules="{ required: true }"
            v-model="$root.formData.card_delivery"
            :radioOptions="$root.selectedLanguageData.colection_details"
            name="Card delivery"
            styles="mt-5"
            itemList="residentship-item"
          />
          <RadioButtonField
            :label="$root.selectedLanguageData.pin_delivery_details"
            :validationRules="{ required: true }"
            v-model="$root.formData.card_pin_delivery"
            :radioOptions="$root.selectedLanguageData.colection_details"
            name="Pin Delivery"
            styles="mt-5"
            itemList="residentship-item"
          />
        </div>
        <div class="mt-5">
          <span class="has-text-primary">
            {{ $root.selectedLanguageData.note }}</span
          >{{ $root.selectedLanguageData.value_added_services_note }}
        </div>
        <PageButton
          :disabled="invalid"
          :previousButtonFunction="
            () => {
              $router.go(-1);
            }
          "
          :nextButtonFunction="
           submitForm()
          "
        />
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import PageButton from "../page-button/page-button.vue";
import PageHeaderPart from "../page-header-part/page-header-part.vue";
import handsettings from "@/assets/images/icons/Blue/hand settings.webp";
import InputLabel from "../fields/input-field.vue";
// import SelectLabel from "../fields/select-field.vue";
import RadioButtonField from "../fields/radio-field.vue";

export default {
  components: {
    PageHeaderPart,
    PageButton,
    InputLabel,
    // SelectLabel,
    RadioButtonField,
  },
  data() {
    return {
      cards: [],
      pageTopImage: handsettings,
      smsToggleButton: "",
      smsYesButton: "",
      smsNoButton: "",
      eBankingToggleButton: "",
      eBankingYesButton: "",
      eBankingNoButton: "",
      virtualWalletToggleButton: "",
      virtualWalletYesButton: "",
      virtualWalletNoButton: "",
      estatementToggleButton: "",
      estatementYesButton: "",
      estatementNoButton: "",
      cardArray: []
    };
  },
  methods: {
    submitForm: function () {
      var comp = this;


      var bodyFormData = new FormData();

      bodyFormData.append("kyc_branch", comp.$root.formData.branch);


      let identificationType = "old-nic";
      if (comp.$root.formData.idType === "ONIC") {
        identificationType = "old-nic";
      } else if (comp.$root.formData.idType === "NNIC") {
        identificationType = "new-nic";
      } else if (comp.$root.formData.idType === "PNO") {
        identificationType = "passport";
      }

      // let publicPositionsHeldBySelf = "No";
      // if (
      //   comp.$root.formData.politically_exposed ==
      //   "public Positions Held BySelf"
      // ) {
      //   publicPositionsHeldBySelf = "Yes";
      // } else {
      //   publicPositionsHeldBySelf = "No";
      // }

      bodyFormData.append("account_type", comp.$root.formData.account_type);
      bodyFormData.append("currency_type", comp.$root.formData.currency_type); // new field to add currency type
      bodyFormData.append(
          "currency_type_code",
          comp.$root.formData.currency_type_code
      ); // new field to add currency type code

      bodyFormData.append("contact_no", comp.$root.formData.mobileNumber);
      bodyFormData.append(
          "contact_no_work",
          comp.$root.formData.officeNumber
      );
      bodyFormData.append(
          "contact_no_resident",
          comp.$root.formData.residentNumber
      );
      bodyFormData.append("email", comp.$root.formData.email);
      bodyFormData.append("title", comp.$root.formData.title);

      bodyFormData.append("name_with_init", comp.$root.formData.name_with_init);
      bodyFormData.append("full_name", comp.$root.formData.full_name);
      bodyFormData.append("nic_type", identificationType);
      bodyFormData.append("customer_nic", comp.$root.formData.customer_nic); // done - adjust the above if else


      bodyFormData.append("gender", comp.$root.formData.gender);



      bodyFormData.append("date_of_birth",comp.formatDate(comp.$root.formData.date_of_birth));

      bodyFormData.append("marital_status", comp.$root.formData.marital_status);
      bodyFormData.append("spouse_name", comp.$root.formData.spouse_name); // todo :: consider - no field is added yet


      bodyFormData.append("citizenship", comp.$root.formData.citizenship);
      bodyFormData.append("residentship", comp.$root.formData.residentship);
      bodyFormData.append("politically_exposed", comp.$root.formData.politically_exposed);
      //console.log("politically_exposed-----> "+comp.$root.formData.politically_exposed)
      bodyFormData.append("politically_exposed_position", comp.$root.formData.politically_exposed_position);
      //console.log("politically_exposed_position-----> "+comp.$root.formData.politically_exposed_position)

      bodyFormData.append(
          "politically_exposed_relative",
          comp.$root.formData.politically_exposed_relative
      );
      bodyFormData.append(
          "politically_exposed_relative_position",
          comp.$root.formData.politically_exposed_relative_position
      );



      // bodyFormData.append("nature_of_business",comp.$root.formData.natureOfEmployment);
      bodyFormData.append('occupation',comp.$root.formData.occupation);
      bodyFormData.append(
          "employment_position",
          comp.$root.formData.employment_position
      );
      bodyFormData.append(
          "employment_position_specify",
          comp.$root.formData.employment_position_specify
      );

      bodyFormData.append(
          "employment_position_spouse",
          comp.$root.formData.employment_position_spouse
      ); // todo :: no field is added yet
      bodyFormData.append("employer_name", comp.$root.formData.employer_name);
      bodyFormData.append(
          "employer_name_spouse",
          comp.$root.formData.employer_name_spouse
      ); // todo :: no field is added yet
      bodyFormData.append("employer_addr", comp.$root.formData.employer_addr);
      bodyFormData.append(
          "purpose_of_opening",
          comp.$root.formData.purpose_of_opening.value
          // comp.getValuesSeperatedWithCommas(

          // )
      );
      bodyFormData.append(
          "source_of_income",
          comp.$root.formData.source_of_income
      );
      //console.log("source_of_income-----> "+comp.$root.formData.source_of_income)

      bodyFormData.append(
          "source_of_income_specify",
          comp.$root.formData.other_source_of_income
      );
      //console.log("source_of_income_specify-----> "+comp.$root.formData.other_source_of_income)

      bodyFormData.append(
          "income_details",
          comp.$root.formData.income_details
      );
      bodyFormData.append(
          "anticipated_vol",
          comp.$root.formData.anticipated_vol.value
      );
      bodyFormData.append(
          "expected_delivery_channel",
          comp.$root.formData.expected_delivery_channel.value
      );
      bodyFormData.append(
          "other_businesses",
          comp.$root.formData.other_businesses
      );


      // newly added fields start ----------------------------------------------------------------------------

      //account select page
      bodyFormData.append("preferred_branch", comp.$root.formData.branch);
      // bodyFormData.append("account_type", comp.$root.formData.account_type);
      bodyFormData.append("account", comp.$root.formData.account);
      bodyFormData.append("time_period", comp.$root.formData.account_time_period);
      bodyFormData.append("selected_account", comp.$root.formData.account_name);

      //personal information page
      bodyFormData.append("residentship_country", comp.$root.formData.resident_country);
      bodyFormData.append("driving_licence", comp.$root.formData.account_holder_driving_licence);
      bodyFormData.append("customer_passport_no", comp.$root.formData.account_holder_passport_number);
      //console.log("passport_no-----> "+comp.$root.formData.account_holder_passport_number);
      bodyFormData.append("passport_issue_date", comp.$root.formData.account_holder_passport_issue_date);
      //console.log("passport_issue_date-----> "+comp.$root.formData.account_holder_passport_issue_date);
      bodyFormData.append("passport_expiry_date", comp.$root.formData.account_holder_passport_expiry_date);
      //console.log("passport_expiry_date-----> "+comp.$root.formData.account_holder_passport_expiry_date);
      bodyFormData.append("tax_payer", comp.$root.formData.tax_payer);
      bodyFormData.append("tax_file_number", comp.$root.formData.tax_file_number);

      //purpose page
      // bodyFormData.append("purpose_of_opening_usage", comp.$root.formData.purpose_of_opening);
      bodyFormData.append("purpose_of_opening_usage_specify", comp.$root.formData.other_purpose_of_opening);

      bodyFormData.append("source_of_funds", comp.$root.formData.source_of_fund);
      //console.log("source of funds-----> "+ comp.$root.formData.source_of_fund)

      bodyFormData.append("source_of_funds_specify", comp.$root.formData.other_source_of_fund);
      //console.log("source_of_funds_specify-----> "+ comp.$root.formData.other_source_of_fund)

      bodyFormData.append("expected_turnover", comp.$root.formData.expected_turnover.value);
      bodyFormData.append("expected_mode_of_transaction", comp.$root.formData.expected_mode_of_transaction);
      bodyFormData.append("expected_mode_of_transaction_specify", comp.$root.formData.other_expected_mode_of_transaction);
      // bodyFormData.append("")
      bodyFormData.append("asset_residential_property", comp.$root.formData.asset_residential_property);
      bodyFormData.append("asset_financial", comp.$root.formData.asset_financial);
      bodyFormData.append("asset_motor_vehicles", comp.$root.formData.asset_motor_vehicles);
      bodyFormData.append("asset_land_buildings", comp.$root.formData.asset_land_buildings);
      bodyFormData.append("asset_investments_shares", comp.$root.formData.asset_investments_shares);
      bodyFormData.append("asset_other", comp.$root.formData.asset_other);

      bodyFormData.append("asset_specify", comp.$root.formData.other_assets_held);

      bodyFormData.append("asset_residential_property_value", comp.$root.formData.asset_residential_property_value);
      bodyFormData.append("asset_investments_shares_value", comp.$root.formData.asset_investments_shares_value);
      bodyFormData.append("asset_land_buildings_value", comp.$root.formData.asset_land_buildings_value);
      bodyFormData.append("asset_motor_vehicles_value", comp.$root.formData.asset_motor_vehicles_value);
      bodyFormData.append("asset_financial_value", comp.$root.formData.asset_financial_value);
      bodyFormData.append("asset_other_value", comp.$root.formData.asset_other_value);


      //vas page
      bodyFormData.append("vas_sms_alerts", comp.$root.formData.sms_service);
      bodyFormData.append("vas_internet_banking", comp.$root.formData.e_banking_service);
      bodyFormData.append("vas_virtual_wallet", comp.$root.formData.virtual_wallet_service);
      bodyFormData.append("vas_estatement", comp.$root.formData.estatement_service);
      bodyFormData.append("vas_debit_card", comp.$root.formData.debit_card_service);
      bodyFormData.append("vas_pos_required", comp.$root.formData.pos_required);
      bodyFormData.append("vas_acc_linked_pos_transaction", comp.$root.formData.account_to_be_linked);
      bodyFormData.append("vas_card_delivery_details", comp.$root.formData.card_delivery);
      bodyFormData.append("vas_pin_delivery_details", comp.$root.formData.card_pin_delivery);
      bodyFormData.append("vas_card_type", comp.$root.formData.facility_debit_card_type);
      bodyFormData.append("mother_maiden_name", comp.$root.formData.mother_maiden_name);

      //document page
      bodyFormData.append("birth_certificate_front_image", comp.$root.productImages.birth_certificate_front_image);
      bodyFormData.append("birth_certificate_back_image", comp.$root.productImages.birth_certificate_back_image);
      bodyFormData.append("passport_bio_page_image", comp.$root.productImages.passport_bio_page_image);
      bodyFormData.append("passport_alterations_page_image", comp.$root.productImages.passport_alteration_page_image);
      bodyFormData.append("passport_entry_stamp_page_image", comp.$root.productImages.passport_entry_stamp_page_image);
      bodyFormData.append("driving_licence_image", comp.$root.productImages.driving_licence_image);

      //us person perment and mailing address
      bodyFormData.append("us_person_permanent_address_line1", comp.$root.formData.us_person_permanent_address_line1);
      bodyFormData.append("us_person_permanent_address_line2", comp.$root.formData.us_person_permanent_address_line2);
      bodyFormData.append("us_person_permanent_address_line3", comp.$root.formData.us_person_permanent_address_line3);
      bodyFormData.append("us_person_permanent_address_postal_code", comp.$root.formData.us_person_permanent_address_postal_code);
      bodyFormData.append("us_person_permanent_address_country", comp.$root.formData.us_person_permanent_address_country);
      bodyFormData.append("us_person_mailing_address_line1", comp.$root.formData.us_person_mailing_address_line1);
      bodyFormData.append("us_person_mailing_address_line2", comp.$root.formData.us_person_mailing_address_line2);
      bodyFormData.append("us_person_mailing_address_line3", comp.$root.formData.us_person_mailing_address_line3);
      bodyFormData.append("us_person_mailing_address_postal_code", comp.$root.formData.us_person_mailing_address_postal_code);
      bodyFormData.append("us_person_mailing_address_country", comp.$root.formData.us_person_mailing_address_country);



      // bodyFormData.append("")
      // bodyFormData.append("", comp.$root.formData.us_person);

      bodyFormData.append("us_person", comp.$root.formData.us_person);
      bodyFormData.append("mailing_address_in_us_same_as_permanent_address", comp.$root.formData.mailing_address_in_us_same_as_permanent_address_in_us);


      bodyFormData.append(
          "us_person_account_numbers",
          comp.$root.formData.us_person_account_numbers
      );
      bodyFormData.append(
          "us_person_place_of_birth",
          comp.$root.formData.us_person_place_of_birth
      );
      bodyFormData.append(
          "us_person_permanent_address",
          comp.$root.formData.us_person_permanent_address
      );
      bodyFormData.append(
          "us_person_correspondent_address",
          comp.$root.formData.us_person_correspondent_address
      );
      bodyFormData.append(
          "us_person_passport_no",
          comp.$root.formData.us_person_passport_no
      );
      bodyFormData.append(
          "us_person_telephone_no",
          comp.$root.formData.us_person_telephone_no
      );

      if (
          comp.$root.formData.citizenship === "Sri Lankan with Dual Citizenship"
      ) {
        bodyFormData.append(
            "dual_citizen_countries",
            comp.$root.formData.dual_citizen_countries
        );
      } else if (
          comp.$root.formData.citizenship ===
          "Foreign National with Dual Citizenship"
      ) {
        bodyFormData.append(
            "dual_citizen_countries",
            comp.$root.formData.dual_citizen_countries.toString()
        );
      }

      bodyFormData.append(
          "us_person_tax_identification_no",
          comp.$root.formData.us_person_tax_identification_no
      );
      bodyFormData.append(
          "facility_internet_banking",
          comp.$root.formData.facility_internet_banking
      );
      bodyFormData.append(
          "facility_debit_card",
          comp.$root.formData.facility_debit_card
      );
      bodyFormData.append(
          "facility_debit_card_type",
          comp.$root.formData.facility_debit_card_type
      );
      bodyFormData.append(
          "vas_visa_card_name",
          comp.$root.formData.facility_debit_card_customer_name
      );

      bodyFormData.append(
          "foreign_national_country",
          comp.$root.formData.foreign_national_country
      );
      bodyFormData.append(
          "resident_countries",
          JSON.stringify(comp.$root.formData.resident_countries)
      );
      bodyFormData.append(
          "visa_proof_doc",
          comp.$root.productImages.visa_proof_doc
      );




      // bodyFormData.append("indemnity", indemnity);
      bodyFormData.append(
          "locationAccess",
          comp.$root.formData.nicNumberAllowToLocationServicesInYourBrowser
      );
      bodyFormData.append(
          "nicVerificationDRP",
          comp.$root.formData.nicNumberAllowToDRP
      );

      // bodyFormData.append('keystroke_dynamics', JSON.stringify(comp.$root.keyStrokeDynamics));
      bodyFormData.append(
          "keystroke_dynamics",
          JSON.stringify(comp.$root.keyStrokeDynamics)
      ); // this was added - used in other branches
      // bodyFormData.append("keystroke_dynamics",JSON.stringify(comp.$root.keyStrokeStatics)); // this was added

      bodyFormData.append(
          "face_ids",
          JSON.stringify(comp.$root.formData.face_ids)
      ); //added

      bodyFormData.append(
          "location_details",
          JSON.stringify(comp.$root.formData.location_details)
      );

      var language = "en";
      if (comp.$root.selectedLanguage == "en") {
        language = "english";
      } else if (comp.$root.selectedLanguage == "ta") {
        language = "tamil";
      } else {
        language = "sinhala";
      }

      bodyFormData.append("preferred_language", language);
      bodyFormData.append("introduced_by", comp.$root.formData.introduced_by);

      bodyFormData.append(
          "nic_front_image",
          comp.$root.productImages.nic_front_image
      );
      bodyFormData.append(
          "nic_back_image",
          comp.$root.productImages.nic_back_image
      );
      bodyFormData.append(
          "selfie_image",
          comp.$root.productImages.selfie_image
      );
      bodyFormData.append("sign_image", comp.$root.productImages.sign_image);
      bodyFormData.append(
          "addr_proof_doc",
          comp.$root.productImages.addr_proof_doc
      );



      // new modification - 2022-9-22 - new field adding ---------------------------------------------------------------
      bodyFormData.append(
          "passport_image",
          comp.$root.productImages.passport_image
      );
      bodyFormData.append(
          "customer_passport_no",
          comp.$root.formData.account_holder_passport_number.toUpperCase()
      );

      bodyFormData.append("customer_preferred_time", comp.$root.formData.videoCallTimeSlot);
      bodyFormData.append("customer_preferred_date", comp.$root.formData.videoCallDate);


      // permanent address
      bodyFormData.append(
          "permanent_address_line1",
          comp.$root.formData.permanent_address_line1
      );
      bodyFormData.append(
          "permanent_address_line2",
          comp.$root.formData.permanent_address_line2
      );
      bodyFormData.append(
          "permanent_address_line3",
          comp.$root.formData.permanent_address_line3
      );
      bodyFormData.append(
          "permanent_address_postal_code",
          comp.$root.formData.permanent_address_postal_code
      );
      bodyFormData.append(
          "permanent_address_country",
          comp.$root.formData.permanent_address_country
      );

      bodyFormData.append(
          "mailing_address_same_as_permanent_address",
          comp.$root.formData.mailing_address_same_as_permanent_address
      );

      // mailing address
      bodyFormData.append(
          "mailing_address_line1",
          comp.$root.formData.mailing_address_line1
      );
      bodyFormData.append(
          "mailing_address_line2",
          comp.$root.formData.mailing_address_line2
      );
      bodyFormData.append(
          "mailing_address_line3",
          comp.$root.formData.mailing_address_line3
      );
      bodyFormData.append(
          "mailing_address_postal_code",
          comp.$root.formData.mailing_address_postal_code
      );
      bodyFormData.append(
          "mailing_address_country",
          comp.$root.formData.mailing_address_country
      );

      // foreign address
      bodyFormData.append(
          "foreign_address_line1",
          comp.$root.formData.foreign_address_line1
      );
      bodyFormData.append(
          "foreign_address_line2",
          comp.$root.formData.foreign_address_line2
      );
      bodyFormData.append(
          "foreign_address_line3",
          comp.$root.formData.foreign_address_line3
      );
      bodyFormData.append(
          "foreign_address_postal_code",
          comp.$root.formData.foreign_address_postal_code
      );
      bodyFormData.append(
          "foreign_address_country",
          comp.$root.formData.foreign_address_country
      );

      // us-person correspondent address
      bodyFormData.append(
          "correspondent_address_line1",
          comp.$root.formData.correspondent_address_line1
      );
      bodyFormData.append(
          "correspondent_address_line2",
          comp.$root.formData.correspondent_address_line2
      );
      bodyFormData.append(
          "correspondent_address_line3",
          comp.$root.formData.correspondent_address_line3
      );
      bodyFormData.append(
          "correspondent_address_postal_code",
          comp.$root.formData.correspondent_address_postal_code
      );
      bodyFormData.append(
          "correspondent_address_country",
          comp.$root.formData.correspondent_address_country
      );

      bodyFormData.append("surname", comp.$root.formData.surname);
      bodyFormData.append("other_name", comp.$root.formData.other_name);
      let kyc_token = comp.$root.formData.kyc_token +'.'+ comp.$root.formData.color_code4 +'.'+ comp.$root.formData.color_code12;

      comp.$http
          .post(comp.$baseURL + "/kycForm/submitAccountInfoKycForm", bodyFormData, {
            headers: { "Content-Type": "multipart/form-data","X-token":kyc_token },
          })
          .then(function (response) {
            //handle success
            console.log("kyc token....",kyc_token)
            console.log("successfully submitted--------------");
            console.log(response);

            comp.isContinueButtonLoading = false;
            comp.$root.isFormSubmitted = true;
            comp.$router.push('documents_id')

            /* comp.$router.push("congratulation");*/
          })
          .catch(function (response) {
            //handle error
            console.log(response);
            comp.$buefy.toast.open({
              message: "Failed to submit form data",
              type: "is-danger",
            });
          });
    },
    formatDate(date){
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate()

      if(month < 10){
        month = "0"+month;
      }
      let output = [month,day,year]
      return output.join("/")
    },

    updateLastStep() {
      try {
        window.element = this;
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12
        this.$http
          .post(this.$baseURL + "/kycForm/updateLastStep", {
            last_step_name:'Employment Info',
            last_step: 5,
            form_filled:true,
            next_route:'Value Added Services',
          },{
            headers:{'X-token':kyc_token}
          })
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              console.log(response.data);
            } else {
              console.log(response.data);
            }
          }).catch((response) => {
            this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
            });
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },

    smsYesClick() {
      if (!this.$root.formData.sms_service) {
        this.smsToggleButton.classList.add("toggle-change");
        this.smsYesButton.classList.add("yes");
        this.smsYesButton.classList.add("yes-active");
        this.smsNoButton.classList.remove("no");
        this.smsNoButton.classList.remove("no-active");
        this.$root.formData.sms_service = true;
        console.log(this.$root.formData.sms_service)
      }
    },
    // calDebitCardName(){
    //   this.$root.formData.facility_debit_card_customer_name = this.$root.formData.other_name.slice(0,1).toUpperCase() +" "+this.$root.formData.surname.toUpperCase();
    //
    // },
    getImagePath(imageFileName) {
      return `/images/${imageFileName}`; // Assuming the public URL points to the root of the public folder
    },
    debitCardDataSetter(){
      if (!this.$root.formData.debit_card_service){
        // this.$root.formData.facility_debit_card_customer_name = ''
        this.$root.formData.mother_maiden_name = ''
        this.$root.formData.facility_debit_card_type = ''
        this.$root.formData.card_delivery = ''
        this.$root.formData.card_pin_delivery = ''
      }
    },

    smsNoClick() {
      if (this.$root.formData.sms_service) {
        this.smsToggleButton.classList.remove("toggle-change");
        this.smsYesButton.classList.remove("yes");
        this.smsYesButton.classList.remove("yes-active");
        this.smsNoButton.classList.add("no");
        this.smsNoButton.classList.add("no-active");
        this.$root.formData.sms_service = false;
        console.log(this.$root.formData.sms_service)
      }
    },

    eBankingYesClick() {
      if (!this.$root.formData.e_banking_service) {
        this.eBankingToggleButton.classList.add("toggle-change");
        this.eBankingYesButton.classList.add("yes");
        this.eBankingYesButton.classList.add("yes-active");
        this.eBankingNoButton.classList.remove("no");
        this.eBankingNoButton.classList.remove("no-active");
        this.$root.formData.e_banking_service = true;
      }
    },

    eBankingNoClick() {
      if (this.$root.formData.e_banking_service) {
        this.eBankingToggleButton.classList.remove("toggle-change");
        this.eBankingYesButton.classList.remove("yes");
        this.eBankingYesButton.classList.remove("yes-active");
        this.eBankingNoButton.classList.add("no");
        this.eBankingNoButton.classList.add("no-active");
        this.$root.formData.e_banking_service = false;
      }
    },
    virtualWalletYesClick() {
      if (!this.$root.formData.virtual_wallet_service) {
        this.virtualWalletToggleButton.classList.add("toggle-change");
        this.virtualWalletYesButton.classList.add("yes");
        this.virtualWalletYesButton.classList.add("yes-active");
        this.virtualWalletNoButton.classList.remove("no");
        this.virtualWalletNoButton.classList.remove("no-active");
        this.$root.formData.virtual_wallet_service = true;
      }
    },

    virtualWalletNoClick() {
      if (this.$root.formData.virtual_wallet_service) {
        this.virtualWalletToggleButton.classList.remove("toggle-change");
        this.virtualWalletYesButton.classList.remove("yes");
        this.virtualWalletYesButton.classList.remove("yes-active");
        this.virtualWalletNoButton.classList.add("no");
        this.virtualWalletNoButton.classList.add("no-active");
        this.$root.formData.virtual_wallet_service = false;
      }
    },

    estatementYesClick() {
      if (!this.$root.formData.estatement_service) {
        this.estatementToggleButton.classList.add("toggle-change");
        this.estatementYesButton.classList.add("yes");
        this.estatementYesButton.classList.add("yes-active");
        this.estatementNoButton.classList.remove("no");
        this.estatementNoButton.classList.remove("no-active");
        this.$root.formData.estatement_service = true;
      }
    },

    estatementNoClick() {
      if (this.$root.formData.estatement_service) {
        this.estatementToggleButton.classList.remove("toggle-change");
        this.estatementYesButton.classList.remove("yes");
        this.estatementYesButton.classList.remove("yes-active");
        this.estatementNoButton.classList.add("no");
        this.estatementNoButton.classList.add("no-active");
        this.$root.formData.estatement_service = false;

      }
    },
    debitCardYesClick() {
      if (!this.$root.formData.debit_card_service) {
        this.debitCardToggleButton.classList.add("toggle-change");
        this.debitCardYesButton.classList.add("yes");
        this.debitCardYesButton.classList.add("yes-active");
        this.debitCardNoButton.classList.remove("no");
        this.debitCardNoButton.classList.remove("no-active");
        this.$root.formData.debit_card_service = true;
        console.log(this.$root.formData.debit_card_service)
        this.getCardList();
      }
    },

    debitCardNoClick() {
      if (this.$root.formData.debit_card_service) {
        this.debitCardToggleButton.classList.remove("toggle-change");
        this.debitCardYesButton.classList.remove("yes");
        this.debitCardYesButton.classList.remove("yes-active");
        this.debitCardNoButton.classList.add("no");
        this.debitCardNoButton.classList.add("no-active");
        this.$root.formData.debit_card_service = false;
      }
      this.$root.formData.pin_collection_details = "";
      this.$root.formData.collection_details = "";
      this.$root.formData.facility_debit_card_customer_name = "";
      this.$root.formData.account_to_be_linked_for_pos_transaction = "";
      // this.$root.formData.pos_required = "";
      this.$root.formData.pos_required = false;
    },
    getCardList(){
      try{
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
        this.$http
            .post(this.$baseURL + "/kycForm/getCards", {},{
              headers:{'X-token':kyc_token}
            })
            .then((response) => {
              console.log(response.data.data.cards);
              this.cardArray = response.data.data.cards;
              console.log("---------------------");
            })

      }catch(err){
        console.log(err)
      }
    },
  },
  computed: {},


  mounted() {
    this.updateLastStep();

    // sms


    this.smsToggleButton = document.getElementById("sms-toggle-buttons");
    this.smsYesButton = document.getElementById("sms-yes-button");
    this.smsNoButton = document.getElementById("sms-no-button");
    if (this.$root.formData.sms_service) {
      this.smsNoButton.classList.remove("no");
      this.smsNoButton.classList.remove("no-active");
    } else {
      this.smsYesButton.classList.remove("yes");
      this.smsYesButton.classList.remove("yes-active");
      this.smsToggleButton.classList.remove("toggle-change");
    }
    // e-banking
    this.eBankingToggleButton = document.getElementById(
      "e-banking-toggle-buttons"
    );
    this.eBankingYesButton = document.getElementById("e-banking-yes-button");
    this.eBankingNoButton = document.getElementById("e-banking-no-button");
    if (this.$root.formData.e_banking_service) {
      this.eBankingNoButton.classList.remove("no");
      this.eBankingNoButton.classList.remove("no-active");
    } else {
      this.eBankingYesButton.classList.remove("yes");
      this.eBankingYesButton.classList.remove("yes-active");
      this.eBankingToggleButton.classList.remove("toggle-change");
    }
    // virtual-wallet
    this.virtualWalletToggleButton = document.getElementById(
      "virtual-wallet-toggle-buttons"
    );
    this.virtualWalletYesButton = document.getElementById(
      "virtual-wallet-yes-button"
    );
    this.virtualWalletNoButton = document.getElementById(
      "virtual-wallet-no-button"
    );
    if (this.$root.formData.virtual_wallet_service) {
      this.virtualWalletNoButton.classList.remove("no");
      this.virtualWalletNoButton.classList.remove("no-active");
    } else {
      this.virtualWalletYesButton.classList.remove("yes");
      this.virtualWalletYesButton.classList.remove("yes-active");
      this.virtualWalletToggleButton.classList.remove("toggle-change");
    }
    // estatement
    this.estatementToggleButton = document.getElementById(
      "estatement-toggle-buttons"
    );
    this.estatementYesButton = document.getElementById("estatement-yes-button");
    this.estatementNoButton = document.getElementById("estatement-no-button");
    if (this.$root.formData.estatement_service) {
      this.estatementNoButton.classList.remove("no");
      this.estatementNoButton.classList.remove("no-active");
    } else {
      this.estatementYesButton.classList.remove("yes");
      this.estatementYesButton.classList.remove("yes-active");
      this.estatementToggleButton.classList.remove("toggle-change");
    }
    // debit_card_service

    this.debitCardToggleButton = document.getElementById(
      "debit_card-toggle-buttons"
    );
    this.debitCardYesButton = document.getElementById("debit_card-yes-button");
    this.debitCardNoButton = document.getElementById("debit_card-no-button");

    if (!this.$root.formData.debit_card_service) {
      this.debitCardToggleButton.classList.remove("toggle-change");
      this.debitCardYesButton.classList.remove("yes");
      this.debitCardYesButton.classList.remove("yes-active");
      this.debitCardNoButton.classList.add("no");
      this.debitCardNoButton.classList.add("no-active");
    } else {
      this.debitCardToggleButton.classList.add("toggle-change");
      this.debitCardYesButton.classList.add("yes");
      this.debitCardYesButton.classList.add("yes-active");
      this.debitCardNoButton.classList.remove("no");
      this.debitCardNoButton.classList.remove("no-active");
      this.getCardList();

    }


  },
};
</script>
<style>
.toggle-button {
  display: flex;
  border: 1px solid #333333;
  max-width: 200px;
  justify-content: flex-end;
  border-radius: 500px;
}

.toggle-change {
  justify-content: flex-start;
}

.toggle-button:hover {
  cursor: pointer;
}

.no-active,
.yes-active {
  background-color: #0099ab;
  color: white;
}

.no,
.yes {
  border-radius: 500px;
}

.toggle-common {
  padding: 0 22px;
}
</style>
